import { NgModule } from '@angular/core';

import { SwitchComponent } from './components';

@NgModule({
    declarations: [
        SwitchComponent
    ],
    exports: [
        SwitchComponent,
    ],
})

export class SwitchModule {}
